import React from 'react';
import styled from 'styled-components';
import { usePreproductPreviewContext } from './context/Context';
import { useIframeReady } from './hooks/useIframeReady';
import { getEmbedUrl } from './utils/getEmbedUrl';
import { jsx as _jsx } from "react/jsx-runtime";
var IframeComponent = styled.iframe.withConfig({
  displayName: "Iframe__IframeComponent",
  componentId: "sc-1ozvz7v-0"
})(["width:100%;height:100%;border:none;opacity:1;transition:opacity 0.3s ease-in-out;"]);
export var Iframe = function Iframe(_ref) {
  var _iframeConfig$width, _iframeConfig$height;

  var templateKey = _ref.templateKey,
      queryParams = _ref.queryParams;

  var _usePreproductPreview = usePreproductPreviewContext(),
      iframeState = _usePreproductPreview.iframeState,
      iframeConfig = _usePreproductPreview.iframeConfig;

  useIframeReady();
  return /*#__PURE__*/_jsx(IframeComponent, {
    src: getEmbedUrl({
      preproductBaseUrl: iframeConfig.preproductBaseUrl,
      templateKey: templateKey,
      queryParams: queryParams
    }),
    "data-testid": "preproduct-preview-iframe",
    title: iframeConfig.title,
    ref: iframeState.iframeRef,
    $width: (_iframeConfig$width = iframeConfig.width) !== null && _iframeConfig$width !== void 0 ? _iframeConfig$width : '100%',
    $height: (_iframeConfig$height = iframeConfig.height) !== null && _iframeConfig$height !== void 0 ? _iframeConfig$height : '100%',
    isVisible: iframeState.isIframeReady,
    allowFullScreen: true
  });
};